import ActionMenu from "@common/dropdowns/actionMenu"
import { TableHeadCellProps } from "@common/table/types"
import { Action } from "@common/types"
import React from "react"

export const ColumnActionMenu = ({ table, header }: TableHeadCellProps) => {
  const {
    options: { enablePinning },
  } = table
  const { column } = header

  const actions = [
    ...(enablePinning
      ? [
          {
            key: "pin_to_left",
            display: "Pin to Left",
            disabled: column.getIsPinned() === "left" || !column.getCanPin(),
          },
          {
            key: "pin_to_right",
            display: "Pin to Right",
            disabled: column.getIsPinned() === "right" || !column.getCanPin(),
          },
          {
            key: "unpin",
            display: "Unpin",
            disabled: !column.getIsPinned(),
          },
        ]
      : []),
  ]

  const handlePinColumn = (pinDirection: "left" | "right" | false) => {
    column.pin(pinDirection)
  }

  const handleActionClick = (action: Action) => {
    switch (action.key) {
      case "pin_to_left":
        handlePinColumn("left")
        break
      case "pin_to_right":
        handlePinColumn("right")
        break
      case "unpin":
        handlePinColumn(false)
        break

      default:
        break
    }
  }
  return (
    <div className="invisible group-hover:visible">
      <ActionMenu
        actions={actions}
        showIconMenu={false}
        onActionClick={handleActionClick}
        showIconMenuOnHover
      />
    </div>
  )
}
